import { NewCard } from "@components/Cards/Templates/newCard";
import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { TENANT } from "@types/tenant";

interface ShoppersCloudSettingsCardProps {
  tenantData: TENANT;
  updateTenantData: (key: keyof TENANT, value: string | boolean) => void;
  loading: boolean;
  isCreate: boolean;
}

export const ShoppersCloudSettingsCard: React.FC<
  ShoppersCloudSettingsCardProps
> = ({ tenantData, updateTenantData, loading, isCreate }: any) => {
  return (
    <NewCard
      header="ShoppersCloudの設定"
      bodyLabel=""
      loading={loading}
      bodyContents={
        <div>
          {isCreate && (
            <>
              <TextInputField
                label={"SIP Node Server"}
                placeholder="example.com"
                required
                value={tenantData?.sip_node_server}
                onChange={(e) =>
                  updateTenantData("sip_node_server", e.target.value.trim())
                }
              />

              <div className="mt-5 divider" />

              <TextInputField
                label={"SIP Incom Server"}
                placeholder="example.com"
                required
                value={tenantData?.sip_incom_server}
                onChange={(e) =>
                  updateTenantData("sip_incom_server", e.target.value.trim())
                }
              />
              <div className="mt-5 divider" />
            </>
          )}

          <TextInputField
            label={"API URL"}
            placeholder="example.com"
            required
            value={tenantData?.shoppers_cloud_url}
            disabled={!isCreate}
            onChange={(e) =>
              updateTenantData("shoppers_cloud_url", e.target.value.trim())
            }
          />
          {!isCreate && (
            <>
              <div className="mt-5 divider" />

              <TextInputField
                label="Sub Directory"
                placeholder="XMPL"
                required
                value={tenantData?.sub_directory}
                disabled={true}
              />
            </>
          )}
        </div>
      }
    />
  );
};
